export default function packet(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="22.663"
      height="22.789"
      viewBox="0 0 22.663 22.789"
    >
      <g
        id="Group_4423"
        data-name="Group 4423"
        transform="translate(-76.815 -47.619)"
      >
        <g id="Path_9774" data-name="Path 9774">
          <path
            id="Path_9779"
            data-name="Path 9779"
            d="M88.1,70.408,76.815,66.063V51.979L88.1,56.133l11.378-4.15V65.87Zm-9.789-5.375L88.094,68.8l9.884-3.944V54.126l-9.88,3.6-9.783-3.6Z"
            fill="#fff"
          />
        </g>
        <g id="Path_9775" data-name="Path 9775">
          <path
            id="Path_9780"
            data-name="Path 9780"
            d="M77.357,53.372l-.533-1.4,11.462-4.35,11.162,4.353-.545,1.4L88.278,49.227Z"
            fill="#fff"
          />
        </g>
        <g id="Path_9776" data-name="Path 9776">
          <rect
            id="Rectangle_833"
            data-name="Rectangle 833"
            width="1.5"
            height="12"
            transform="translate(87.383 57.152)"
            fill="#fff"
          />
        </g>
        <g id="Path_9777" data-name="Path 9777">
          <path
            id="Path_9781"
            data-name="Path 9781"
            d="M90.612,52.369l4.012,1.74v4.37l-2.5.913V55.106l-3.9-1.655Z"
            fill="#fff"
          />
        </g>
        <g id="Path_9778" data-name="Path 9778">
          <path
            id="Path_9782"
            data-name="Path 9782"
            d="M80.557,62.929l2.528.953v1.344l-2.528-.985Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}